import { getConfiguration, verifyExtend, ExtendError } from "./extend-utils.js";
import { productAnalytics } from "./extend-analytics.js";

class ExtendProduct extends HTMLElement {
    constructor(productForm, addToCartButton) {
        super();

        const referenceId = productForm.id.value;
        const price = meta.product.variants.filter(variant => variant.id == referenceId)[0].price;
        const category = meta.product.type;

        this.offerParams = {
            referenceId,
            price,
            category
        }
        
        this.config = getConfiguration();
        this.config.dispatchSideCart = false;
        
        this.productForm = productForm,
        this.addToCartButton = addToCartButton;
        this.quantityEl = this.productForm.querySelector('input[name="quantity"]');
    }
    
    connectedCallback() {

        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }
     
        this.bindEvents();
        
        if (!this.config.pdpOfferEnabled) this.style.display = 'none';
        // Renders Extend offer
        Extend.buttons.render(this, this.offerParams);
    }
    
    bindEvents() {
        // this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this), true);
        // this.productForm.addEventListener('submit', this.handleAddToCart.bind(this), true);
        
        this.productForm.addEventListener('change', this.handleVariantChange.bind(this), true);
    }
    
    verifyProductOffer() {

        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.offerParams.referenceId',
            'this.offerParams.price'
//            'this.offerParams.category'
        ]
        
        let missingElements = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });
        
        if (missingElements.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingElements.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }
        
        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();
        
    }
    
    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e, callback) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const quantity = this.quantityEl && this.quantityEl.value ? this.quantityEl.value : 1;
        
        ExtendShopify.handleAddToCart(this, {
            quantity: quantity,
            modal: this.config.modalOfferEnabled,
            done: typeof callback == 'function' ? callback : this.handleAddToCartDone.bind(this) 
        });
    }

    handleAddToCartDone() {
        // Trigger Analytics
        if (this.config.analyticsEnabled) productAnalytics(this.offerParams.referenceId, quantity);

        // // remove default click listener
        // // this.addToCartButton.removeEventListener('click', this.handleAddToCart, true);
        // this.productForm.removeEventListener('submit', this.handleAddToCart);
        // // click atc button
        // this.addToCartButton.click();
        // // add default click listener back
        // // this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this), true);
        // this.productForm.addEventListener('submit', this.handleAddToCart, true)
    }
    
    handleVariantChange() {
        // Flicker prevention
        this.style.height = `${this.clientHeight}px`;

        this.offerParams.referenceId = this.productForm.id.value;
        this.offerParams.price = meta.product.variants.filter(variant => variant.id == this.offerParams.referenceId)[0].price;
        
        
        Extend.setActiveProduct(this, this.offerParams);
    }
}
customElements.define('extend-offer', ExtendProduct);

/**
* Initializes product offers and handles ATC button functionality for the main PDP ATC
*/
export function initProductOffer() {
    if (meta.page.pageType != 'product' || !meta.product) return;

    const productFormSelector = 'form.product-purchase-form';
    const addToCartButtonSelector = 'button[data-add-to-cart-text]';

    const productForm = document.querySelector(productFormSelector);
    const addToCartButton = productForm ? productForm.querySelector(addToCartButtonSelector) : document.querySelector(addToCartButtonSelector);
    
    // Create offer and render it
    const extendOffer = new ExtendProduct(productForm, addToCartButton);
    addToCartButton.parentElement.before(extendOffer);
}